module.exports = __webpack_public_path__ + "static/itsm_capabilities_11-e90165f7c38ad8f0594fe6124b50dc27.png";